import type { Invoice } from '../types/invoice';
import { fetchInvoicePdf } from './invoiceApi';
import { printPdfBlob } from './printPdfBlob';

/**
 * Prints the server-generated invoice PDF (same document as download/email).
 */
export const printSalesInvoice = async (
  invoice: Pick<Invoice, 'id' | 'invoice_number'>
): Promise<void> => {
  const { blob } = await fetchInvoicePdf(invoice.id, `${invoice.invoice_number}.pdf`);
  await printPdfBlob(blob);
};
